import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DatePipe, JsonPipe, NgIf} from "@angular/common";
import {AlertService, IAlertType, NotificationStoreService} from "../../../../_shared/services";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";

import { environment as env } from '../../../../../environments/environment';
import {ClrCommonFormsModule, ClrIconModule} from "@clr/angular";
import {ClarityIcons, exclamationCircleIcon, floppyIcon} from "@cds/core/icon";

@Component({
  selector: 'app-notification-edit-positions',
  standalone: true,
  imports: [
    NgIf,
    JsonPipe,
    ClrIconModule,
    ClrCommonFormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './notification-edit-positions.component.html',
  styleUrl: './notification-edit-positions.component.sass'
})
export class NotificationEditPositionsComponent implements OnInit  {

  public editNotificationsForm!: FormGroup;
  positions: any;

  @Input() projectNumber: string = '';
  @Input() notificationNumber: number = 0;
  @Input() editPosition: number = 0;
  @Input() editPart: number = 0;
  @Output() updatedPosition = new EventEmitter();

  devMode: boolean = false;

  constructor(
    private notss: NotificationStoreService,
    private alertDispatcher: AlertService,
    private fb: FormBuilder
  ) {
    ClarityIcons.addIcons(floppyIcon, exclamationCircleIcon);
    this.devMode = env.stages.dev;
  }

  ngOnInit(): void {
    this.loadNotificationsPosition(this.projectNumber, this.notificationNumber, this.editPosition, this.editPart);
  }

  initForm() {
    if (this.editNotificationsForm) {
      return;
    }

    this.editNotificationsForm = this.fb.group({
      name: [this.positions[0].name],
      notification_id: [this.positions[0].notification_id],
      number_of_pieces: [this.positions[0].number_of_pieces],
      part: [this.positions[0].part],
      position: [this.positions[0].position],
      project_id: [this.positions[0].project_id],
      remarks: [this.positions[0].remarks],
      technical_drawing: [this.positions[0].technical_drawing],
      comment_phm: [this.positions[0].comment_phm],
      specification: [this.positions[0].specification],
      description: [this.positions[0].description],
      side_agreements: [this.positions[0].side_agreements],
    });
  }

  loadNotificationsPosition(prpjectID: string, notificationID: number, position: number, part: number) {
    this.notss.getNotificationsPositions(prpjectID, notificationID, position, part).subscribe({
      next: data => {
      if (!data || data.hasErrors || !data.message) {
        this.alertDispatcher.show({
          message: ' Request-Position konnte nicht geladen werden.',
          clrAlertType: IAlertType.WARNING
        }, 5000);
        return;
      }
      this.positions = data.object;

      if (this.devMode) console.table(data);
      if (this.devMode) console.table(this.positions);

      this.initForm();
    },
      error: (error) => {
      this.alertDispatcher.show({
        message: 'Fehler beim Laden der Position: ' + error,
        clrAlertType: IAlertType.DANGER
      }, 5000);
    }
  });
}

  updateNotificationsPosition() {
    if (this.editNotificationsForm.valid) {
      const formValue = this.editNotificationsForm.value;
      this.notss.updateNotificationsPosition(formValue).subscribe({
        next: () => {
          this.alertDispatcher.show({
            message: 'Position erfolgreich aktualisiert',
            clrAlertType: IAlertType.SUCCESS
          }, 5000);

          this.updatedPosition.emit(true);
        },
        error: (error) => {
          this.alertDispatcher.show({
            message: 'Fehler beim Aktualisieren der Position: ' + error,
            clrAlertType: IAlertType.DANGER
          }, 5000);
        }
      });
    }
  }
}
